"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const urls_1 = require("./urls");
const stories_1 = require("./stories");
const auth_1 = require("./auth");
exports.default = {
    submitStoriesForm: stories_1.submitStoriesForm,
    getStoryById: stories_1.getStoryById,
    getAllStories: stories_1.getAllStories,
    updateStory: stories_1.updateStory,
    submitLogin: auth_1.submitLogin,
    urls: urls_1.routeURLS,
    fullUrls: urls_1.fullURLS,
};
//# sourceMappingURL=index.js.map